<template>
  <!-- 左上 FAB: 選択中レイヤーのext-ダイアログを一括表示/非表示 -->
  <div v-if="showFab" class="ext-dialog-fab-container">
    <MiniTooltip :text="allDialogsOpen ? 'レイヤー設定を閉じる' : 'レイヤー設定を開く'" :offset-x="0" :offset-y="0">
      <v-btn
        v-track="'ext-dialog-fab-btn'"
        class="ext-dialog-fab"
        :color="hasExtDialogs ? (allDialogsOpen ? 'orange' : 'green') : 'grey'"
        size="small"
        icon
        elevation="2"
        :disabled="!hasExtDialogs"
        @click="toggleAllExtDialogs"
      >
        <v-icon size="24" :color="allDialogsOpen ? 'white' : undefined">{{ allDialogsOpen ? 'mdi-tune-vertical' : 'mdi-tune' }}</v-icon>
        <span v-if="extDialogCount > 0" class="ext-dialog-badge">{{ extDialogCount }}</span>
      </v-btn>
    </MiniTooltip>

    <!-- 教員ダッシュボードボタン（教員のみ） -->
    <MiniTooltip v-if="isTeacher" :text="isLessonSyncActive ? '授業配信中（クリックでダッシュボード）' : '教員ダッシュボード'" :offset-x="0" :offset-y="0">
      <v-btn
        v-track="'teacher-dashboard'"
        class="ext-dialog-fab org-admin-btn"
        :class="{ 'teacher-sync-pulse': isLessonSyncActive }"
        :color="isLessonSyncActive ? 'error' : 'primary'"
        size="small"
        icon
        elevation="2"
        @click="$store.commit('setShowTeacherDashboard', true)"
      >
        <v-icon size="24">mdi-school</v-icon>
      </v-btn>
    </MiniTooltip>

    <!-- 組織管理ボタン（管理者のみ、教員でない場合） -->
    <MiniTooltip v-if="isOrganizationOwner && !isTeacher" text="組織管理" :offset-x="0" :offset-y="0">
      <v-btn
        v-track="'organization-admin'"
        class="ext-dialog-fab org-admin-btn"
        color="primary"
        size="small"
        icon
        elevation="2"
        @click="$store.commit('setShowOrganizationAdmin', true)"
      >
        <v-icon size="24">mdi-domain</v-icon>
      </v-btn>
    </MiniTooltip>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MiniTooltip from '@/components/MiniTooltip.vue'

export default {
  name: 'ExtDialogFab',
  components: { MiniTooltip },
  computed: {
    ...mapState([
      'isPrint',
      'isIframe',
      'isTeacher',
      'isOrganizationOwner',
      'activeLesson',
      'dialogsInfo',
      'floatingWindows'
    ]),
    isLessonSyncActive() {
      return !!(this.activeLesson && this.activeLesson.syncEnabled)
    },
    showFab() {
      // 印刷モード、iframeでは非表示
      if (this.isPrint || this.isIframe) return false
      return true
    },
    // ext-ダイアログの情報を取得（map01のみ）
    extDialogs() {
      const info = this.dialogsInfo?.map01 || []
      // extプロパティを持つもののみ（通常のラスターは除外）
      return info.filter(item => item.ext)
    },
    hasExtDialogs() {
      return this.extDialogs.length > 0
    },
    extDialogCount() {
      return this.extDialogs.length
    },
    // 全てのext-ダイアログが開いているかどうか
    allDialogsOpen() {
      if (!this.hasExtDialogs) return false
      return this.extDialogs.every(item => {
        const windowId = 'dialog-ext-map01-' + item.id
        return this.floatingWindows?.[windowId] === true
      })
    }
  },
  methods: {
    toggleAllExtDialogs() {
      if (!this.hasExtDialogs) return

      const shouldClose = this.allDialogsOpen

      this.extDialogs.forEach((item) => {
        const windowId = 'dialog-ext-map01-' + item.id
        this.$store.commit('setFloatingVisible', { id: windowId, visible: !shouldClose })
      })
    }
  }
}
</script>

<style scoped>
.ext-dialog-fab-container {
  position: absolute;
  top: 130px;
  left: 10px;
  z-index: 3; /* zoom-info-btnと同じ */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ext-dialog-fab {
  width: 48px !important;
  height: 48px !important;
  min-width: 48px !important;
  border-radius: var(--oh3-radius-full) !important;
  box-shadow: 0 3px 8px var(--oh3-color-overlay-20) !important;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
  position: relative;
}

.ext-dialog-fab:hover:not(:disabled) {
  transform: scale(1.1) !important;
  box-shadow: 0 4px 15px var(--oh3-color-overlay-30) !important;
}

.ext-dialog-fab:active:not(:disabled) {
  transform: scale(0.95) !important;
}

.ext-dialog-fab:disabled {
  opacity: 0.5;
}

.org-admin-btn {
  margin-top: 8px;
}

.ext-dialog-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  font-size: var(--oh3-font-size-xs);
  font-weight: bold;
  line-height: 18px;
  text-align: center;
  color: var(--oh3-color-text-inverse);
  background-color: #f44336;
  border-radius: 9px;
}

/* モバイル対応 */
@media (max-width: 500px) {
  .ext-dialog-fab-container {
    top: 110px;
    left: 8px;
  }

  .ext-dialog-fab {
    width: 40px !important;
    height: 40px !important;
    min-width: 40px !important;
  }
}

/* 印刷時は非表示 */
@media print {
  .ext-dialog-fab-container {
    display: none !important;
  }
}
</style>
